'use strict';

"use strict";
const pluginVersion = "12.4.2";

exports.pluginVersion = pluginVersion;
